<div class="flex-direction-column height-100-com-titulo-pag page">
  <div class="flex gap-15 wrap abas-parametros">
    <app-card-botao-parametro
      img="./assets/icones/ldap.svg"
      texto="AD"
      widthImg="60px"
      [selecionado]="abaAtiva === 'ad'"
      (click)="selecionarAba('ad')"
    ></app-card-botao-parametro>
    <app-card-botao-parametro
      img="./assets/icones/webhook-icon.svg"
      texto="Webhook"
      widthImg="30px"
      [selecionado]="abaAtiva === 'webhook'"
      (click)="selecionarAba('webhook')"
    ></app-card-botao-parametro>
    <app-card-botao-parametro
      img="./assets/icones/key.svg"
      texto="Token"
      widthImg="30px"
      [selecionado]="abaAtiva === 'token'"
      (click)="selecionarAba('token')"
    ></app-card-botao-parametro>
    <app-card-botao-parametro
      img="./assets/icones/canal.svg"
      texto="Plataformas"
      widthImg="30px"
      [selecionado]="abaAtiva === 'plataforma'"
      (click)="selecionarAba('plataforma')"
    ></app-card-botao-parametro>
    <app-card-botao-parametro
      img="./assets/icones/icon-aws-ses.png"
      texto="AWS SES"
      widthImg="60px"
      [selecionado]="abaAtiva === 'awsSes'"
      (click)="selecionarAba('awsSes')"
    ></app-card-botao-parametro>
    <app-card-botao-parametro
      img="./assets/logo-integrax-parametros.png"
      texto="IntegraX"
      widthImg="90px"
      [selecionado]="abaAtiva === 'integrax'"
      (click)="selecionarAba('integrax')"
    ></app-card-botao-parametro>
    <app-card-botao-parametro
      img="./assets/icones/azure-acs-icon-parametro.png"
      texto="Azure ACS"
      widthImg="60px"
      [selecionado]="abaAtiva === 'azureAcs'"
      (click)="selecionarAba('azureAcs')"
    ></app-card-botao-parametro>
    <app-card-botao-parametro
      img="./assets/icones/whatsapp-roxo.svg"
      texto="WhatsApp"
      widthImg="32px"
      [selecionado]="abaAtiva === 'whatsapp'"
      (click)="selecionarAba('whatsapp')"
    ></app-card-botao-parametro>
    <app-card-botao-parametro
      img="./assets/icones/icon-integ-parametros.svg"
      widthImg="30px"
      texto="Integração"
      [selecionado]="abaAtiva === 'integracao'"
      (click)="selecionarAba('integracao')"
    ></app-card-botao-parametro>
  </div>

  <div class="banner-descricao margin-top-10">
    <span class="material-icons banner-descricao__icone">
      <img src="./assets/icones/icon-info-parametros.svg" alt="">
    </span>
    <span class="banner-descricao__texto">{{ descricaoAba }}</span>
  </div>

  <div class="margin-top-10 width-99">
    @if (abaAtiva === 'ad') {
      <app-card-ad></app-card-ad>
    } @else if (abaAtiva === 'webhook') {
      <app-card-webhook></app-card-webhook>
    } @else if (abaAtiva === 'token') {
      <app-card-token></app-card-token>
    } @else if (abaAtiva === 'plataforma') {
      <app-card-plataforma></app-card-plataforma>
    } @else if (abaAtiva === 'awsSes') {
      <app-card-aws-ses></app-card-aws-ses>
    } @else if (abaAtiva === 'integrax') {
      <app-card-integrax-sms></app-card-integrax-sms>
    } @else if (abaAtiva === 'azureAcs') {
      <app-card-azure-acs></app-card-azure-acs>
    } @else if (abaAtiva === 'whatsapp') {
      <app-card-whatsapp></app-card-whatsapp>
    } @else if (abaAtiva === 'integracao') {
      <app-card-integracao></app-card-integracao>
    }
  </div>
</div>
